<template>
  <div
    class="d-flex homepageContainer"
    :class="$store.state.screenMode === 'dark' ? 'dark' : ''"
  >
    <Navbar
      class="w-25"
      @clicked="categoryClicked"
      :categories="cats"
      :social="social"
    />
    <CategoryTemplate
      class="w-100"
      :selectedCategory="selectedCategory"
      :allTools="tools"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "../components/Home/Navigation/Navbar";
import CategoryTemplate from "../components/Home/Templates/CategoryTemplate";

export default {
  name: "Home",
  components: {
    CategoryTemplate,
    Navbar,
  },
  computed: {
    userUID() {
      return this.$store.state.userObj.uid
        ? this.$store.state.userObj.uid
        : localStorage.getItem("uid");
    },
    favTools() {
      return this.$store.state.favoriteTools;
    },
  },
  data: function () {
    return {
      mode: "dark",
      social: [],
      selectedCategory: [],
      allTools: [],
      resulta: "",
      search: this.$store.state.searchedString,
      //API
      tools: [],
      cats: [],
      subcats: [],
      backgrounds: [],
    };
  },
  methods: {
    async categoryClicked(value) {
      //Check if category or other button is clicked
      if (value.toLowerCase() === "favorites") {
        if (this.$store.state.isLoggedIn) {
          await this.$store.dispatch("retrieveUserFavoriteTools");
          if (this.$store.state.favoriteTools.length > 0) {
            this.selectedCategory = {
              categoryTitle: "FAVORITE TOOLS",
              subdivisionTitle: "My favorites",
              categoryNonActive: false,
              tools: this.favTools,
            };
          } else {
            this.selectedCategory = {
              categoryTitle: "FAVORITE TOOLS",
              subdivisionTitle: "You haven't added any favorite tools yet!",
              message: "Find your favorite tools and click on the star icon.",
              categoryNonActive: false,
              tools: this.favTools,
            };
          }
        } else {
          this.selectedCategory = {
            categoryTitle: "FAVORITE TOOLS",
            subdivisionTitle: "Log in to use this feature",
            categoryNonActive: false,
            tools: [],
          };
        }
      } else if (value.toLowerCase() === "instellingen") {
      } else {
        //Tries to find if the clicked category is a valid category
        let selectedCategory = this.cats.find(
          (x) => x.categoryTitle.toLowerCase() === value.toLowerCase()
        );

        if (selectedCategory !== undefined) {
          let selectedCategoryTools = [];
          //The tools that belong to this category will be pushed into the array
          for (let tool of this.tools) {
            if (
              tool.category.toLowerCase() === value.toLowerCase() &&
              tool.subdivision === undefined
            ) {
              selectedCategoryTools.push(tool);
            }
          }
          //Creating an object with the properties that the Vue Component wants to read data from.
          //This object is being passed to the CategoryTemplate
          this.selectedCategory = {
            categoryTitle: selectedCategory.categoryTitle,
            heroImg: selectedCategory.heroImg,
            tools: selectedCategoryTools.reverse(),
          };
        } else {
          //If the selectedCategory ends up being undefined, it means you clicked a subcategory
          //and it will find the tools for it
          for (let category of this.cats) {
            for (let subdiv of category.subdivisions) {
              if (subdiv.subcategoryTitle === value) {
                let selectedSubCategoryTools = [];
                //The tools that belong to this subcategory will be pushed into the array
                for (let tool of this.tools) {
                  if (tool.subdivision === value) {
                    selectedSubCategoryTools.push(tool);
                  }
                }
                this.selectedCategory = {
                  categoryTitle: category.categoryTitle,
                  heroImg: category.heroImg,
                  subdivisionTitle: subdiv.subcategoryTitle,
                  tools: selectedSubCategoryTools.reverse(),
                };
              }
            }
          }
        }
      }

      //TODO: Clear the search input in CategoryTemplate
    },
    fetchTools(client) {
      let arrayy = [];
      // gets all the valid tools from api
      client
        .getEntries({
          content_type: "tool",
        })
        .then(async (entries) => {
          entries.items.forEach((entry) => {
            let logo = "";
            let webprev = "";
            if (entry.fields.logo !== undefined) {
              logo = entry.fields.logo.fields.file.url;
            }
            if (entry.fields.websitePreview !== undefined) {
              webprev = entry.fields.websitePreview.fields.file.url;
            }

            let obj = {
              title: entry.fields.title,
              description: entry.fields.description,
              category: entry.fields.category,
              subdivision: entry.fields.subdivision,
              website: entry.fields.website,
              logo: logo,
              websitePreview: webprev,
            };
            arrayy.push(obj);
          });
          this.tools = arrayy;
          this.fetchCategories(client);
        });
    },
    async fetchCategories(client) {
      let array = [];
      // gets all valid categories from api
      await client
        .getEntries({
          content_type: "category",
        })
        .then(async (entries) => {
          entries.items.forEach((entry) => {
            let obj = {
              categoryTitle: entry.fields.categoryTitle,
              heroImg: entry.fields.heroImg.fields.file.url,
              categoryIconNonActive:
                entry.fields.categoryIconNonActive.fields.file.url,
              categoryIconActive:
                entry.fields.categoryIconActive.fields.file.url,
              active: false,
            };
            array.push(obj);
          });

          array = array.sort((a, b) =>
            a.categoryTitle.localeCompare(b.categoryTitle)
          );

          this.cats = array;
          this.fetchSubCategories(client);
        });
    },
    fetchSubCategories(client) {
      let array = [];
      // gets all valid subcategories from api
      client
        .getEntries({
          content_type: "subcategory",
        })
        .then(async (entries) => {
          entries.items.forEach((entry) => {
            let obj = {
              mainCategoryTitle: entry.fields.mainCategoryTitle,
              subcategoryTitle: entry.fields.subcategoryTitle,
              categoryIconNonActive:
                entry.fields.categoryIconNonActive.fields.file.url,
              categoryIconActive:
                entry.fields.categoryIconActive.fields.file.url,
              active: false,
            };
            array.push(obj);
          });
          this.subcats = array;
          this.createNavigation(client);
        });
    },
    createNavigation(client) {
      this.cats.forEach((navItem) => {
        let tempArray = [];
        this.subcats.forEach((subItem) => {
          if (navItem.categoryTitle === subItem.mainCategoryTitle) {
            tempArray.push(subItem);
          }
        });
        let obj = this.cats.find(
          (x) => x.categoryTitle === navItem.categoryTitle
        );
        obj.subdivisions = tempArray;
      });
    },
  },
  mounted() {
    let elem = document.createElement("script");
    elem.src = "https://cse.google.com/cse.js?cx=d0bfe3afc3b6e489b";
    document.body.appendChild(elem);
  },
  beforeMount() {
    let contentful = require("contentful");
    let client = contentful.createClient({
      space: "h0smdghzpqc3",
      accessToken: "L5Tw2h-q6liPo6SB6qG0-h6DYTLEnOmSYeFMzuhEQVw",
    });
    this.fetchTools(client);
    this.$store.dispatch("retrieveUserFavoriteTools");
    this.social = [
      {
        title: "Facebook",
        link: "https://www.facebook.com/",
        img: "https://www.windowsblogitalia.com/wp-content/uploads/2017/06/facebook-770688_1920.png",
      },
      {
        title: "Instagram",
        link: "https://www.instagram.com/",
        img: "https://store-images.s-microsoft.com/image/apps.31997.13510798887167234.6cd52261-a276-49cf-9b6b-9ef8491fb799.30e70ce4-33c5-43d6-9af1-491fe4679377?mode=scale&q=90&h=300&w=300",
      },
      {
        title: "LinkedIn",
        link: "https://www.linkedin.com/",
        img: "https://play-lh.googleusercontent.com/kMofEFLjobZy_bCuaiDogzBcUT-dz3BBbOrIEjJ-hqOabjK8ieuevGe6wlTD15QzOqw",
      },
      {
        title: "Twitter",
        link: "https://www.twitter.com/",
        img: "https://play-lh.googleusercontent.com/kMofEFLjobZy_bCuaiDogzBcUT-dz3BBbOrIEjJ-hqOabjK8ieuevGe6wlTD15QzOqw",
      },
      {
        title: "TikTok",
        link: "https://www.tiktok.com/",
        img: "https://cdn2.downdetector.com/static/uploads/logo/Tiktok_logo.png",
      },
      {
        title: "Pinterest",
        link: "https://www.pinterest.com/",
        img: "https://digitalnatives.be/wp-content/uploads/2019/10/pinterest_PNG62-e1570175111506-1024x973.png",
      },
      {
        title: "YouTube",
        link: "https://www.youtube.com/",
        img: "https://play-lh.googleusercontent.com/lMoItBgdPPVDJsNOVtP26EKHePkwBg-PkuY9NOrc-fumRtTFP4XhpUNk_22syN4Datc",
      },
      {
        title: "Facebook Ads Manager",
        link: "https://nl-nl.facebook.com/business/tools/ads-manager",
        img: "https://play-lh.googleusercontent.com/Uku36RjbFRupjCW6a8py_Jvk9PY0xYdGK-zXyrGxFrcYEq_dKVfFse4ZRY_0LTOFtvdD",
      },
      {
        title: "Google Ads Manager",
        link: "https://admanager.google.com",
        img: "https://storage.googleapis.com/gweb-uniblog-publish-prod/images/logo_admanager_192px_MuAH4Zs.max-800x800.png",
      },
      {
        title: "Twitter Ads Manager",
        link: "https://ads.twitter.com/",
        img: "https://www.bandt.com.au/information/uploads/2021/09/Twitter.png",
      },
    ];
    // this.retrieveUserFavoriteTools();
    this.$store.dispatch("retrieveUserFavoriteTools");
    //this.fetchAllTools();
  },
};
</script>
<style scoped>
.dark {
  background: var(--yungo-darkmode-background) !important;
}

.homepageContainer {
  width: 95vw;
  margin: auto;
}

:deep(p#userName) {
  color: black;
}

:deep(input#searchInput) {
  margin-top: 0 !important;
  margin-left: 0;
}

@media only screen and (max-width: 992px) {
  .homepageContainer {
    flex-wrap: wrap;
  }
}
</style>

<style>
</style>
